export default (percent: number): string => `${percent.toLocaleString()}%`
